import { useEffect, useRef, useState } from 'react';
import { Input } from '@/components/ui/input';
import { COUNTRIES } from '@/shared/constants/country';

interface Props {
	country?: string;
	selectedCountry: { code: string; dial: string };
	onClick: (val: { code: string; dial: string }) => void;
}

const CountrySelect = ({
	country = 'all',
	selectedCountry,
	onClick,
}: Props) => {
	const [open, setOpen] = useState(false);
	const [search, setSearch] = useState('');
	const containerRef = useRef<HTMLDivElement>(null);

	const targetCountries =
		country === 'all'
			? COUNTRIES
			: COUNTRIES.filter(item => item.code === country);

	const filtered = targetCountries.filter(item =>
		item.name.toLowerCase().includes(search.toLowerCase())
	);

	const selectedCountryData = COUNTRIES.find(
		c => c.code === selectedCountry.code
	);

	// 외부 클릭 시 닫기
	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (
				containerRef.current &&
				!containerRef.current.contains(e.target as Node)
			) {
				setOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div ref={containerRef} className="relative min-h-12 basis-1/4">
			<button
				type="button"
				onClick={() => setOpen(prev => !prev)}
				className="flex items-center justify-between w-full h-full px-2.5 py-2 border rounded-md border-gray-05 ">
				<div className="flex items-center gap-2">
					<img src={selectedCountryData?.flag} alt="flag" className="w-6 h-6" />
					<span className="text-base">{selectedCountryData?.dial}</span>
				</div>
			</button>

			{open && (
				<div className="absolute z-10 w-full mt-2 min-w-[180px] bg-white border border-gray-05 rounded-md shadow-md">
					<div className="p-2">
						<Input
							value={search}
							onChange={e => setSearch(e.target.value)}
							placeholder="Search country..."
							className="border border-gray-200 h-9"
						/>
					</div>
					<ul className="overflow-auto text-sm max-h-60 min-w-[180px]">
						{filtered.length > 0 ? (
							filtered.map(item => (
								<li
									key={item.code}
									onClick={() => {
										onClick({ code: item.code, dial: item.dial });
										setOpen(false);
										setSearch('');
									}}
									className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100">
									<img src={item.flag} className="w-6 h-6 rounded-full" />
									<span>{item.name}</span>
								</li>
							))
						) : (
							<li className="px-3 py-2 text-gray-500">No countries found</li>
						)}
					</ul>
				</div>
			)}
		</div>
	);
};

export default CountrySelect;
